import React, { useState, useEffect } from "react";
import Gallery from "react-bnb-gallery";
import { useTranslation } from "react-i18next";
import { slimImage } from "@/service/utils";
import { Drawer, Divider, Typography } from "antd";
import { Header, MapView } from "@/components";
import { getQuery } from "@/service/http";

/**详情 */
export const Details = ({ restaurant }) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  let {
    basic_info = {},
    book_config = {},
    location = {},
    landmarks = [],
    cuisines = [],
    tags: restaurantTags = [],
    licenses = [],
  } = restaurant;

  licenses = licenses.map((item) => item.picture_url);
  const showPolicy = book_config.cancel && book_config.cancel.policy;
  const goList = (name, val) => {
    let { city_restaurants_url } = getQuery();
    let searchSymbol = city_restaurants_url.includes("?") ? "&" : "?";
    let url = `${city_restaurants_url}${searchSymbol}${name}=${val}`;
    window.open(url, "_blank");
  };
  return (
    <section className="page-restaurant--details">
      <h3>{t("WEB.Details")}</h3>
      {/* 餐厅其他信息 */}
      <div className="page-restaurant--others">
        <OpenHour restaurant={restaurant} />
        <h4>{t("WEB.Introduction")}</h4>
        <div
          className="restaurant-description"
          dangerouslySetInnerHTML={{
            __html: basic_info.description,
          }}
        ></div>
        {showPolicy ? (
          <React.Fragment>
            <h4>{t("WEB.Cancellation policy")}</h4>
            <div
              className="restaurant-cancellation"
              dangerouslySetInnerHTML={{
                __html: book_config.cancel.policy,
              }}
            ></div>
          </React.Fragment>
        ) : null}
        <h4>{t("WEB.District")}</h4>
        <div className="restaurant-tags">
          <div
            className="tag-button clickable"
            onClick={() => goList("loc", location.id)}
          >
            {location.name}
          </div>
        </div>
        <h4>{t("WEB.Landmarks")}</h4>
        <div className="restaurant-tags">
          {landmarks.map((item) => {
            return (
              <div
                className="tag-button clickable"
                key={item.id}
                onClick={() => goList("land", item.id)}
              >
                {item.name}
              </div>
            );
          })}
        </div>
        <h4>{t("WEB.Cuisines")}</h4>
        <div className="restaurant-tags">
          {cuisines.map((item) => {
            return (
              <div
                className="tag-button clickable"
                key={item.id}
                onClick={() => goList("cui", item.id)}
              >
                {item.name}
              </div>
            );
          })}
        </div>
        <template v-if="false">
          <h4>{t("WEB.Tags")}</h4>
          <div className="restaurant-tags">
            {restaurantTags.map((item) => {
              return (
                <div
                  className="tag-button clickable"
                  key={item.id}
                  onClick={() => goList("tag", item.id)}
                >
                  {item.name}
                </div>
              );
            })}
          </div>
        </template>

        {!!licenses.length && (
          <>
            <h4>{t("WEB.Licenses")}</h4>
            <div className="restaurant-tags">
              {licenses.map((item, index) => {
                let photo = `${item}?imageView2/1/w/24/h/24/interlace/1`.replace(
                  "??",
                  "?"
                );
                return (
                  <div
                    className="license-button"
                    key={index}
                    onClick={() => setShow(true)}
                  >
                    <img src={photo} alt="" />
                    <i className="icon icon-eye"></i>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
      <Gallery
        onClose={() => setShow(false)}
        photos={licenses}
        show={show}
        showThumbnails={false}
      ></Gallery>
    </section>
  );
};

/* 餐厅标签 */
const Tags = ({ tags }) => {
  return (
    <div className="page-restaurant--tags">
      {tags.map((item, index) => {
        return (
          <div className="tag-item" key={index}>
            <img
              className="tag-icon"
              src={slimImage(item.icon_url, "/w/64/h/64")}
            />
            <div className="tag-content">
              <div className="tag-name">{item.name}</div>
              <div
                className="tag-description"
                dangerouslySetInnerHTML={{
                  __html: item.description,
                }}
              ></div>
              <div className="tag-link">{item.link.text}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

/** 开放时间 */
const OpenHour = ({ restaurant }) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [showMap, setShowMap] = useState(false);
  return (
    <div className="profile-items">
      <div className="profile-openhour">
        <i className="icon icon-time"></i>
        <div className="content">
          <Typography.Paragraph ellipsis={{ rows: 2 }}>
            {restaurant.opening_hour}
          </Typography.Paragraph>
        </div>
      </div>
      <div
        className="profile-openhour-mobile"
        data-show={show}
        onClick={() => setShow(!show)}
      >
        <i className="icon icon-time"></i>
        <div className="content">{restaurant.opening_hour}</div>
        <i className="icon icon-arrow-down"></i>
      </div>
      <Divider type="vertical" />
      <footer className="profile-footer flex">
        <div className="profile-address" onClick={() => setShowMap(true)}>
          <i className="icon icon-location"></i>
          <span>
            <Typography.Paragraph ellipsis={{ rows: 2 }}>
              {restaurant.address}
            </Typography.Paragraph>
          </span>
        </div>
        <Divider type="vertical" />
        <div className="icon-phone-wrap">
          <a className="icon icon-phone" href={`tel:${restaurant.phone}`}></a>
        </div>
      </footer>
      <Drawer
        className="restaurant-drawer"
        placement="right"
        closable={false}
        destroyOnClose
        onClose={() => setShowMap(false)}
        visible={showMap}
      >
        <Header title={t("ADDRESS")} onClick={() => setShowMap(false)} />
        {/* 地图 */}
        <div className="restaurant-map">
          <MapView {...restaurant} showButton={true} />
        </div>
      </Drawer>
    </div>
  );
};
